<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer006" role="doc-toc">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/One#_idTextAnchor000">Chapter One</a></p>
<p class="TOCitem"><a href="#/Two#_idTextAnchor001">Chapter Two</a></p>
<p class="TOCitem"><span href="#/Three#_idTextAnchor002" title="Link target outside of Sample">Chapter Three</span></p>
<p class="TOCitem"><span href="#/Four#_idTextAnchor003" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/Five#_idTextAnchor004" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/Six#_idTextAnchor005" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/Seven#_idTextAnchor006" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/Eight#_idTextAnchor007" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/Nine#_idTextAnchor008" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/Ten#_idTextAnchor009" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/Eleven#_idTextAnchor010" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOCitem"><span href="#/Twelve#_idTextAnchor011" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="TOCitem"><span href="#/Thirteen#_idTextAnchor012" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="TOCitem"><span href="#/Fourteen#_idTextAnchor013" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="TOCitem"><span href="#/Fifteen#_idTextAnchor014" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="TOCitem"><span href="#/Epilogue#_idTextAnchor015" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCitem"><span href="#/Dear_Reader#_idTextAnchor016" title="Link target outside of Sample">Dear Reader</span></p>
<p class="TOCitem"><a href="#/Excerptone#_idTextAnchor017">Excerpt from <i>Tracking a Kidnapper</i> by Valerie Hansen</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?a4753270